import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UsersService {

private apiUrl = `${environment.baseUrl}/user`;
  private mspinUrl = `${environment.baseUrl}/admin/master/masterRecords?type=24`;

  constructor(private http: HttpClient) { }

  createUser(userData: any): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });

    console.log(userData);
    return this.http.post(this.apiUrl, userData, { headers });
  }

  getUserList(): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.get(`${this.apiUrl}/list`, { headers });
  }
  updateUser(id: number, data: any) {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.put(`${this.apiUrl}/update-profile/${id}`, data, { headers });
  }

  getMspin(): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.get(`${this.mspinUrl}`, { headers });
  }
}
